import CuratenieInWeekend from "pages/Servicii/ServiciiSpeciale/CuratenieInWeekend";

export default function CuratenieInWeekendPage() {
    return <CuratenieInWeekend />;
}
